import { makeStyles } from '@material-ui/core/styles';
import { MDSMarqAIBlackLogo } from '@marqvision/mds/core';

const useStyles = makeStyles(() => ({
  box: {
    margin: '64px 20px 20px',
    cursor: 'pointer',
  },
}));

export const LogoWordmark = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.box} onClick={() => (window.location.href = 'https://www.marqvision.com')}>
      <MDSMarqAIBlackLogo size={32} />
    </div>
  );
};
